module.exports = __webpack_public_path__ + "img/enrollprime.a24574af.png";